import { createStyles, Theme } from '@material-ui/core';
import { lighten } from '@material-ui/core/styles/colorManipulator';

const styles = ({ spacing: { unit }, palette }: Theme) =>
  createStyles({
    button: {
      display: 'flex',
      backgroundColor: palette.background.default,
      border: '1px solid transparent',
      width: '100%',
      minHeight: 56,
      padding: `${unit}px ${unit * 1.5}px`,
      cursor: 'pointer',
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      '&:hover': {
        backgroundColor: lighten(palette.primary.main, 0.9),
      },
      '& span': {
        display: 'block ',
      },
    },
    selectedButton: {
      backgroundColor: lighten(palette.primary.main, 0.9),
      borderColor: palette.primary.main,
      height: 'fit-content',
    },
  });

export default styles;
